// Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'

import {
  LabelledDetail,
  Grid
} from '../'


export const PicsaDeductionsAmountGrid = ({ investment, insurance, credit, fees, singleValue }) => (
  <Grid
    columns={4}
    items={[
      <LabelledDetail label='Investment' detail={singleValue || investment} />,
      <LabelledDetail label='Insurance' detail={singleValue || insurance} />,
      <LabelledDetail label='Credit' detail={singleValue || credit} />,
      <LabelledDetail label='Fees' detail={singleValue || fees} />
    ]}
    className='slds-p-top_x-small slds-p-bottom_large slds-p-left_medium slds-p-right_medium'
  />
)



// WEBPACK FOOTER //
// ./src/components/creditapplication-income/PicsaDeductionsAmountGrid.js